var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dialog-content"},[_c('el-dialog',{attrs:{"visible":_vm.dialogVisible,"width":"850px","show-close":_vm.showClose},on:{"update:visible":function($event){_vm.dialogVisible=$event},"close":function($event){return _vm.$emit('close')}}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }